import { render, staticRenderFns } from "./SapMaterialWarehousingList.vue?vue&type=template&id=2a124c36&scoped=true&"
import script from "./SapMaterialWarehousingList.vue?vue&type=script&lang=js&"
export * from "./SapMaterialWarehousingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a124c36",
  null
  
)

export default component.exports